import { PailPlusOutlineIcon } from './PailPlusOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 63B16204-CDD1-425F-8DDD-7DD80F2639D9
 * name pail-plus-outline
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pail-plus-outline.svg
 * tags
 */
export const BucketPlusOutlineIcon = PailPlusOutlineIcon;
export default BucketPlusOutlineIcon